module.exports = __webpack_public_path__ + "static/media/First Light ZTG 3776_1440.8fb27782.jpeg";